// extracted by mini-css-extract-plugin
export default {"price-col":"ServiceTable_price-col__0FnB3"};